<template lang="pug">
div(
    class='mx-auto'
    :style="style"
)
    template(v-for="widget in data.widgets")
        slot(
            :data="widget"
            :spaceLeft="constrainSpaceLeft"
        )
</template>

<script>
import { getMaxWidth } from '../../helpers'

export default {
    name: 'ConstrainWidget',
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
        spaceLeft: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        maxWidth() {
            return getMaxWidth(this.data)
        },
        constrainSpaceLeft() {
            return {
                mobile: this.calculateSpaceLeft(this.spaceLeft.mobile, this.maxWidth.mobile),
                tablet: this.calculateSpaceLeft(this.spaceLeft.tablet, this.maxWidth.tablet),
                desktop: this.calculateSpaceLeft(this.spaceLeft.desktop, this.maxWidth.desktop),
            }
        },
        style() {
            let maxWidth = null

            // Choose maxWidth value based upon device
            if (this.$device.isMobile) maxWidth = this.maxWidth.mobile
            else if (this.$device.isDesktop) maxWidth = this.maxWidth.desktop
            else maxWidth = this.maxWidth.tablet

            // Clamp max width value between 0 and 100
            if (maxWidth) maxWidth = `${Math.min(Math.max(maxWidth, 0), 100)}%`

            return {
                maxWidth,
            }
        },
    },
    methods: {
        calculateSpaceLeft(spaceLeft, maxWidth) {
            if (!maxWidth) return spaceLeft
            return spaceLeft * (maxWidth * 0.01)
        },
    },
}
</script>
